import {AfterViewInit, Directive, effect, inject, Injector, runInInjectionContext} from '@angular/core';
import {Store} from '@ngxs/store';
import {RouterState} from 'ngxs-ui-router';
import {TabGroupComponent} from '../../components/tab-group/tab-group.component';
import {toSignal} from '@angular/core/rxjs-interop';

@Directive({
  selector: '[msRouterTabs]',
})
export class RouterTabsDirective implements AfterViewInit {
  private readonly store = inject(Store);
  private readonly tabGroup = inject(TabGroupComponent);
  private readonly injector = inject(Injector);

  routeName = toSignal(this.store.select(RouterState.routeName));

  ngAfterViewInit() {
    runInInjectionContext(this.injector, () => {
      effect(() => {
        const active = this.tabGroup.tabs().find(tab => this.routeName().includes(tab.name()));
        if (active) {
          this.tabGroup.activeTab.set(active.name());
        }
      });
    });
  }
}
